
export default {
  name: 'orientationOptions',

  props: {
    orientation: {
      type: Number,
      required: true,
      default: 2 // 1: 竖屏; 2: 横屏
    },

    // 默认显示两个选项
    showOrientation: {
      type: Array,
      default: function _default() {
        return ['portrait', 'landscape'];
      }
    },

    size: {
      type: String,
      default: 'medium'
    }
  },

  methods: {
    changePortrait: function changePortrait() {
      if (this.showOrientation.indexOf('portrait') !== -1) {
        this.$emit('changeOrientation', {
          orientation: 1
        });
      }
    },
    changeLandscape: function changeLandscape() {
      if (this.showOrientation.indexOf('landscape') !== -1) {
        this.$emit('changeOrientation', {
          orientation: 2
        });
      }
    }
  }
};